export const UPDATE_VERSION_DATA = {
  message:
    'A <b>new version</b> of this app is available! Would you like to <b>update</b>?',
  actions: { confirm: true, cancel: true },
};

export const VERSION_READY = 'VERSION_READY';
export const IS_PROMPTED_KEY = 'isPromptedToInstall';

// Hook for the unencapsulated panel styles in pwa-snackbar.component.scss.
export const SNACKBAR_PANEL_CLASS = 'ft-pwa-snackbar';
